/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FAnonymousType112 } from './FAnonymousType112';
import {
    FAnonymousType112FromJSON,
    FAnonymousType112FromJSONTyped,
    FAnonymousType112ToJSON,
    FAnonymousType112ToJSONTyped,
} from './FAnonymousType112';

/**
 * 
 * @export
 * @interface FAnonymousType124
 */
export interface FAnonymousType124 {
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType124
     */
    id?: number;
    /**
     * 
     * @type {FAnonymousType112}
     * @memberof FAnonymousType124
     */
    definition?: FAnonymousType112;
    /**
     * 
     * @type {string}
     * @memberof FAnonymousType124
     */
    status?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FAnonymousType124
     */
    created?: Date;
}

/**
 * Check if a given object implements the FAnonymousType124 interface.
 */
export function instanceOfFAnonymousType124(value: object): value is FAnonymousType124 {
    return true;
}

export function FAnonymousType124FromJSON(json: any): FAnonymousType124 {
    return FAnonymousType124FromJSONTyped(json, false);
}

export function FAnonymousType124FromJSONTyped(json: any, ignoreDiscriminator: boolean): FAnonymousType124 {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'definition': json['definition'] == null ? undefined : FAnonymousType112FromJSON(json['definition']),
        'status': json['status'] == null ? undefined : json['status'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
    };
}

export function FAnonymousType124ToJSON(json: any): FAnonymousType124 {
    return FAnonymousType124ToJSONTyped(json, false);
}

export function FAnonymousType124ToJSONTyped(value?: FAnonymousType124 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'definition': FAnonymousType112ToJSON(value['definition']),
        'status': value['status'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
    };
}

